import { render, staticRenderFns } from "./SchemeBarChart.vue?vue&type=template&id=1fcaf658"
import script from "./SchemeBarChart.vue?vue&type=script&lang=js"
export * from "./SchemeBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports